import React, { useEffect } from 'react'
import { useState } from 'react'
import { Outlet, NavLink, useParams, useNavigate } from 'react-router-dom'
import {FaArrowLeft} from "react-icons/fa"
import "./orgStyle.css"
import { api } from '../../app/Api/ApiSlice'



const Org = () => {
    const { organization } = useParams()
    const [members, setMembers] = useState("")
    const [friends, setFriends] = useState("")
    const [isAdmin, setIsAdmin] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        const getOrgInfo = async () => {
            const response = await api.get(`/${organization}`)
            // console.log(response)
            if (response) {
                setMembers(response.data.org.membersCount)
                setFriends(response.data.org.friendsCount)
                setIsAdmin(response.data.org.isAdmin)
            }
        }

        getOrgInfo()
    }, [])



    // const isAdmin = true
    return (
        <div className='page-body'>
            <div className="multi-content-page">
                <div className="page-side-menu">
                    <div className="menu-items-list">
                        <div className='page-menu-item'>
                            <div className='menu-back-btn'>
                                <p onClick={() => navigate("/organizations")}><FaArrowLeft/>  Back</p>
                            </div>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}`}>Posts</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/members`}>{`members (${members})`}</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/friends/`}>{`friends (${friends})`}</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/branches`}>Branches</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/admins`}>Admins</NavLink>
                        </div>
                        <div className='page-menu-item'>
                            <NavLink to={`/${organization}/suggestionbox`}>Suggestion Box</NavLink>
                        </div>
                        {
                            isAdmin &&
                            <div className='page-menu-item'>
                                <NavLink to={`/${organization}/admin`}>Manage</NavLink>
                            </div>
                        }
                    </div>
                </div>
                <div className="org-content" id="org-content">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Org